/**
 * 获取语言包
 */
export const getLang = (type) => {
    let langType;
    let content = type && type.toUpperCase() == 'LOCAL' ? window.localStorage.getItem('lang') : window.sessionStorage.getItem('lang');
    if ('string' === typeof content && content === 'zh') langType = 1;
    if ('string' === typeof content && content === 'en') langType = 2;
    if ('string' === typeof content && content === 'tibet') langType = 3;
    return langType;
}